import*as ActionTypes from'./actionTypes';export var openContextMenu=function openContextMenu(){var elementId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var menuType=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var helperProps=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};return{type:ActionTypes.OPEN_CONTEXT_MENU,elementId:elementId,menuType:menuType,helperProps:helperProps};};export var closeContextMenu=function closeContextMenu(){return{type:ActionTypes.CLOSE_CONTEXT_MENU};};


//////////////////
// WEBPACK FOOTER
// ./src/store/actions/contextMenu.js
// module id = 1863
// module chunks = 29